import {PaymentMethodProps} from "../typings/wc-types";
import styles from './WigWagLabel.module.scss';
import {WigWagSettings} from "./types";

export default function WigWagLabel(_props: PaymentMethodProps) {
    const settings = window.wc.wcSettings.getSetting<WigWagSettings>('wigwag_data');

    return (
        <div className={styles['wigwag-label']}>
            <span>WigWag</span>
            <div className={styles.icons}>
                <img src={settings.mc_icon_url} alt="Mastercard"/>
                <img src={settings.visa_icon_url} alt="visa"/>
            </div>
        </div>
    )
}
